module.exports = __webpack_public_path__ + "img/yy.ad905404.jpg";